import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {BaseError} from "../../components/pages/base-error";

@Injectable()
export class MonitoringControllerService extends BaseError {

  private baseUrl: string = environment.BASE_URL;
  private dsUrl: string = environment.E_REGISTRATIONS_URL;
  private appUrl: string = environment.APP_URL;
  private gdbUrl: string = environment.GDB_URL;

  constructor(private http: HttpClient,
              public toastr: ToastrService) {
    super(toastr);
  }

  public getBEVersion(): Observable<any> {
    return this.http.get(this.baseUrl + "info", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
  }

  public getBEStatus(): Observable<any> {
    return this.http.get(this.baseUrl + "health", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
  }

  public getDSBeStatus(): Observable<any> {
    return this.http.get(this.dsUrl + "status", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
  }

  public getDSFeStatus(): Observable<any> {
    return this.http.get(this.dsUrl + "status", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
  }

  public getFEVersion(): Observable<any> {
    return this.http.get(this.appUrl + "/version", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
  }

  public getFEStatus(): Observable<any> {
    return this.http.get(this.appUrl + "/health", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
  }

  public getGDBStatus(): Observable<any> {
    return this.http.get(this.gdbUrl + "api/v1/status", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
  }
}
